import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Play, Pause, RotateCcw, Plus, Minus } from 'lucide-react';

const TimerControls = ({ 
  game, 
  localTime, 
  syncing, 
  onTimerAction, 
  onSetTime, 
  onUpdateStoppage 
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <Button
          data-testid="timer-start-btn"
          onClick={() => onTimerAction('start')}
          disabled={game.is_running || syncing}
          className="h-20 bg-[#22C55E] hover:bg-[#16A34A] text-white font-body text-xl touch-target"
        >
          <Play className="w-8 h-8 mr-2" />
          START
        </Button>
        <Button
          data-testid="timer-pause-btn"
          onClick={() => onTimerAction('pause')}
          disabled={!game.is_running || syncing}
          className="h-20 bg-[#EF4444] hover:bg-[#DC2626] text-white font-body text-xl touch-target"
        >
          <Pause className="w-8 h-8 mr-2" />
          PAUSE
        </Button>
      </div>
      
      {/* Quick Time Adjustments */}
      <Card className="bg-[#1E293B] border-slate-700">
        <CardHeader className="pb-2">
          <CardTitle className="text-white font-body text-sm">Adjust Time</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-4 gap-2">
            <Button
              data-testid="time-minus-60"
              onClick={() => onSetTime(Math.max(0, localTime - 60))}
              disabled={syncing}
              className="h-14 bg-slate-700 hover:bg-slate-600 text-white font-mono touch-target"
            >
              -1:00
            </Button>
            <Button
              data-testid="time-minus-30"
              onClick={() => onSetTime(Math.max(0, localTime - 30))}
              disabled={syncing}
              className="h-14 bg-slate-700 hover:bg-slate-600 text-white font-mono touch-target"
            >
              -0:30
            </Button>
            <Button
              data-testid="time-plus-30"
              onClick={() => onSetTime(localTime + 30)}
              disabled={syncing}
              className="h-14 bg-slate-700 hover:bg-slate-600 text-white font-mono touch-target"
            >
              +0:30
            </Button>
            <Button
              data-testid="time-plus-60"
              onClick={() => onSetTime(localTime + 60)}
              disabled={syncing}
              className="h-14 bg-slate-700 hover:bg-slate-600 text-white font-mono touch-target"
            >
              +1:00
            </Button>
          </div>
          <Button
            data-testid="timer-reset-btn"
            onClick={() => onSetTime(0)}
            disabled={syncing}
            className="w-full mt-2 h-12 bg-slate-800 hover:bg-slate-700 text-slate-300 font-body touch-target"
          >
            <RotateCcw className="w-4 h-4 mr-2" />
            Reset to 0:00
          </Button>
        </CardContent>
      </Card>

      {/* Stoppage Time */}
      <Card className="bg-[#1E293B] border-slate-700">
        <CardHeader className="pb-2">
          <CardTitle className="text-white font-body text-sm">Stoppage Time</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center gap-4">
            <Button
              data-testid="stoppage-minus"
              onClick={() => onUpdateStoppage(-1)}
              disabled={syncing}
              className="h-14 w-14 bg-slate-700 hover:bg-slate-600 text-white touch-target"
            >
              <Minus className="w-6 h-6" />
            </Button>
            <span className="font-mono text-4xl text-[#F97316]">+{game.stoppage_time || 0}'</span>
            <Button
              data-testid="stoppage-plus"
              onClick={() => onUpdateStoppage(1)}
              disabled={syncing}
              className="h-14 w-14 bg-slate-700 hover:bg-slate-600 text-white touch-target"
            >
              <Plus className="w-6 h-6" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TimerControls;
